import {Component, OnInit} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {GetNewsService, NewsService, StorageService} from "../../providers";

@Component({
  selector: 'page-news-detail',
  templateUrl: 'news-detail.html'
})
export class NewsDetailPage implements OnInit {
  newsBody = '';
  keywords = [];
  title = '';
  photo;
  content;
  newsId;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public newsService: NewsService,
    public viewCtrl: ViewController,
    public getNewsService: GetNewsService,
    private storageService: StorageService
  ) {}

  ionViewDidLoad() {
    // console.log('ionViewDidLoad NewsDetailPage');
  }

  ngOnInit() {
    this.loadNews(+this.navParams.get('id'))
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  loadNews(newsId) {
    this.newsService.getNewsT(newsId).subscribe(
      (data) => {
        // console.log(data);
        this.title = data.title;
        this.photo = data.photo;
        this.content = data.text;
        this.newsId = newsId;
        this.newsService.getNews(newsId, data.keys.join(';')).subscribe(
          (content) => {
            this.newsBody = content.text();
            this.prepPrint();
          }
        )
      }
    );

  }

  share() {
    // Unavailable in the browser version
  }

  swipe(event) {
    // console.log(event);
    if (event.direction == 1) {
      this.getNewsService.goTo(this.newsId).subscribe(
        data => {
          if (data.news.prevNewsID) {
            this.loadNews(data.news.prevNewsID)
          }
        },
        err => console.log(err))
    }
    if (event.direction == 2) {
      // console.log('forward');
      this.getNewsService.goTo(this.newsId).subscribe(
        data => {
          if (data.news.nextNewsID) {
            this.loadNews(data.news.nextNewsID)
          }
        },
        err => console.log(err))
    }
  }

  getTextSize () {
    let textSize = this.storageService.get('textSize');
    if (textSize === "Little")
      return '10px';
    else if (textSize === "Normal")
      return '14px';
    else if (textSize === "Large")
      return '16px';
    return '14px';
  }

  private prepPrint() {
    // Create printArea node if it doesn't exist already
    let printArea = document.getElementById('printArea');
    if (!printArea) {
      printArea = document.createElement('div');
      printArea.id = 'printArea';
      document.body.appendChild(printArea);
    }

    // Set news body as the printArea content
    printArea.innerHTML = this.newsBody;

    // TODO: FIX THIS - edit the news text so that it can be printed over multiple pages
    const paragraphs = printArea.getElementsByTagName('p');
    const p = paragraphs.item(paragraphs.length - 1);
    //console.log(p);
    for (let i = 0; i < p.childNodes.length; i++) {
      const n = p.childNodes.item(i).cloneNode(true);
      if (n.nodeName === '#text') {
        const wrapper = document.createElement('p');
        wrapper.innerHTML = n.textContent;
        printArea.appendChild(wrapper);
      } else {
        printArea.appendChild(n);
      }
      //console.log(n);
    }
    p.parentNode.removeChild(p);
  }

  public print() {
    window.print();
  }

}



// WEBPACK FOOTER //
// ./src/pages/news-detail/news-detail.ts